"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var draws_screen_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/draws/draws-screen"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var page_container_1 = require("@pbl/pbl-react-web-components/lib/page-container");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../config/constants"));
var TermsOfUseUpdateModal_1 = __importDefault(require("../../modules/SettingsWidget/profile/completeprofile/TermsOfUseUpdateModal"));
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/authentication/actions");
var actions_3 = require("../../redux/reducers/draws/actions");
var actions_4 = require("../../redux/reducers/loyalty/actions");
var actions_5 = require("../../redux/reducers/profile/actions");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var DrawCard_1 = __importDefault(require("./components/DrawCard"));
var styles_1 = require("./styles");
var PageTitle;
(function (PageTitle) {
    PageTitle["GIVEAWAY"] = "Giveaway";
    PageTitle["SECOND_CHANCE"] = "2nd Chance";
    PageTitle["SWEEPSTAKES"] = "Sweepstakes";
    PageTitle["PROGRESSIVE"] = "Progressive";
    PageTitle["OTHER"] = "Other Promotions";
})(PageTitle || (PageTitle = {}));
var PromotionListScreen = function (_a) {
    var promotionType = _a.promotionType, projectName = _a.projectName, titleComponent = _a.titleComponent;
    var t = (0, react_i18next_1.useTranslation)().t;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.styles)(theme)();
    (0, useScrollToTop_1.useScrollToTop)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = react_1.default.useState(false), pendingRedirect = _b[0], setPendingRedirect = _b[1];
    var _c = (0, react_1.useState)(false), showTermsOfUseUpdateModal = _c[0], setShowTermsOfUseUpdateModal = _c[1];
    var _d = (0, react_1.useState)(false), tosChecked = _d[0], setTosChecked = _d[1];
    var draws = (0, react_redux_1.useSelector)(function (state) { return state.draws; });
    var errorMessage = draws.errorMessage, promotions = draws.promotions, loading = draws.loading, featuredPromotion = draws.featuredPromotion, promotionPage = draws.promotionPage;
    var isGiveaway = promotionType === types_1.PromotionType.GIVEAWAY;
    var _e = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _e.isAuthenticated, isRestricted = _e.isRestricted;
    var _f = (0, react_1.useState)(null), prizeCheck = _f[0], setPrizeCheck = _f[1];
    var checkTermsAndConditions = (0, react_redux_1.useSelector)(function (state) { return state.profile; }).checkTermsAndConditions;
    (0, react_1.useEffect)(function () {
        dispatch((0, actions_2.isAuthenticated)());
        return function () {
            dispatch((0, actions_4.resetState)());
            dispatch((0, actions_1.clearMessages)());
        };
    }, [dispatch]);
    (0, react_1.useEffect)(function () {
        getEntities();
        return function () {
            if (prizeCheck) {
                clearInterval(prizeCheck);
            }
            setPrizeCheck(null);
        };
    }, []);
    var getEntities = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, actions_3.fetchPromotions)(promotionType));
            dispatch((0, actions_3.fetchPromotionsWithoutFeatured)(promotionType, true));
            setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    updateProgressivePrize();
                    return [2];
                });
            }); }, 2500);
            setPrizeCheck(window.setInterval(updateProgressivePrize, constants_1.default.HOME_SCREEN_FETCH_DRAW_INTERVAL));
            return [2];
        });
    }); };
    var redirectContactUs = function () {
        if (constants_1.default.CUSTOM_CONTACT_US_URL && constants_1.default.CUSTOM_CONTACT_US_URL.length > 0) {
            window.location.href = constants_1.default.CUSTOM_CONTACT_US_URL;
            return;
        }
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var updateProgressivePrize = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (((_a = draws === null || draws === void 0 ? void 0 : draws.featuredPromotion) === null || _a === void 0 ? void 0 : _a.promotionType) === types_1.PromotionType.PROGRESSIVE) {
                dispatch((0, actions_3.fetchProgressivePrizes)());
            }
            draws === null || draws === void 0 ? void 0 : draws.promotions.map(function (promotion) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (promotion.promotionType === types_1.PromotionType.PROGRESSIVE) {
                        dispatch((0, actions_3.fetchProgressivePrizes)());
                    }
                    return [2];
                });
            }); });
            return [2];
        });
    }); };
    var getNextPage = function (pageNumber) {
        dispatch((0, actions_3.loadMore)(pageNumber, promotionType, true));
    };
    var onCardClicked = function (promotion) {
        var appNavigate = {
            action: 'PROMOTION_DETAILS',
            data: promotion
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    (0, react_1.useEffect)(function () {
        if (isLoggedIn && !checkTermsAndConditions && constants_1.default.CHECK_TERMS_AND_CONDITIONS_ENABLED) {
            setShowTermsOfUseUpdateModal(true);
        }
        if (pendingRedirect && isLoggedIn) {
            navigateToTicketEntry();
            setPendingRedirect(false);
        }
    }, [isLoggedIn, pendingRedirect]);
    var navigateToTicketEntry = function () {
        if (!isLoggedIn && constants_1.default.V2_CHANGES) {
            var appNavigate = {
                action: 'LOGIN'
            };
            setPendingRedirect(true);
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
        }
        else {
            var appNavigate = {
                action: 'TICKET_ENTRY'
            };
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
        }
    };
    var getSecondChanceTitle = function () {
        if (constants_1.default.V2_CHANGES && promotionType === 'SECOND_CHANCE') {
            return t('ticket.draw.SECOND_CHANCE_WV');
        }
        if (constants_1.default.SECOND_CHANCE_V2 && promotionType === 'SECOND_CHANCE') {
            return t('ticket.draw.SECOND_CHANCE');
        }
        return PageTitle[promotionType];
    };
    var secondChanceTitle = getSecondChanceTitle();
    var renderDrawsScreenTitle = function () { return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
        react_1.default.createElement("div", { className: classes.header },
            react_1.default.createElement(package_1.Title, { withoutButtonIcon: !constants_1.default.V2_CHANGES && !constants_1.default.WITH_BUTTON_ICON, icon: constants_1.default.HIDE_REWARD_EARN_LIST_ICON ? undefined : 'icon-draws', title: secondChanceTitle, titleColor: 'textPrimary', buttonText: isGiveaway
                    ? undefined
                    : constants_1.default.V2_CHANGES && projectName !== 'KS'
                        ? t('games.submitTicket')
                        : t('games.enterTicket'), buttonTextTitle: isGiveaway
                    ? undefined
                    : constants_1.default.V2_CHANGES && projectName !== 'KS'
                        ? t('games.submitTicket')
                        : t('games.enterTicket'), navigateToTicketEntry: navigateToTicketEntry, disabled: isRestricted && isLoggedIn, isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs, titleComponent: titleComponent })))); };
    var getDrawCard = function (promotion, onClick) {
        var _a;
        return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, lg: 4, key: promotion.id },
            react_1.default.createElement(DrawCard_1.default, { name: promotion.name, image: promotion.fullImage ? promotion.fullImage : '', description: (_a = promotion.description) !== null && _a !== void 0 ? _a : '', onClick: onClick, iconName: 'icon-draws', banner: {
                    showBanner: !!promotion.getPromotionStatus() ||
                        (!!promotion.progressivePrize && promotion.isJackpotReached()),
                    bannerText: promotion.getPromotionStatus()
                        ? t("draw.drawStatus.".concat(promotion.getPromotionStatus()))
                        : t('draws.progressive.maxJackPot'),
                    styleType: promotion.isEnded()
                        ? 'GrayedOut'
                        : promotion.isEndingSoon()
                            ? 'WhiteHighlight'
                            : 'Active'
                }, promotionType: promotion.promotionType, promotionProgressivePrize: promotion.progressivePrize })));
    };
    var onSubmitTos = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, actions_5.updateTermsAndConditions)());
            dispatch((0, actions_5.fetchTermsAndConditions)());
            setShowTermsOfUseUpdateModal(false);
            return [2];
        });
    }); };
    var handleTosChecked = function () {
        setTosChecked(!tosChecked);
    };
    if (errorMessage) {
        return (react_1.default.createElement("div", { className: classes.container },
            react_1.default.createElement(package_1.LoadError, { onReloadIconPress: getEntities, text: "Something went wrong while loading the content!" })));
    }
    if (loading) {
        var contentLoader = (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, md: 4 },
            react_1.default.createElement(package_1.CardContentLoader, { loaderStyle: 'loyalty' })));
        return (react_1.default.createElement("div", { className: classes.container },
            renderDrawsScreenTitle(),
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 4 },
                contentLoader,
                react_1.default.createElement(core_1.Hidden, { smDown: true }, contentLoader),
                react_1.default.createElement(core_1.Hidden, { xsDown: true }, contentLoader))));
    }
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(page_container_1.Container, null,
            react_1.default.createElement(draws_screen_1.default, { renderTitle: renderDrawsScreenTitle, promotions: promotions, page: promotionPage, loading: loading, featuredPromotion: featuredPromotion, getNextPage: getNextPage, getCard: getDrawCard, onCardClicked: onCardClicked, itemsPerPage: constants_1.default.DRAWS_PER_PAGE, featuredTitleWrap: true, disablePagination: constants_1.default.DISABLE_SECOND_CHANCE_PAGINATION }),
            react_1.default.createElement(TermsOfUseUpdateModal_1.default, { show: showTermsOfUseUpdateModal, tosChecked: tosChecked, onSubmitTos: onSubmitTos, handleTosChecked: handleTosChecked }))));
};
exports.default = PromotionListScreen;
//# sourceMappingURL=index.js.map